export default "<div *ngIf=\"displayLoader\" class=\"loader\">\r\n</div>\r\n<div *ngIf=\"displayLoader\" class=\"loader-backdrop\"></div>"